import { combineReducers } from "@reduxjs/toolkit";
import { getAllAudioLanguageReducer } from "./slices";

const audioLanguageReducer = combineReducers({
  getAllAudioLanguage: getAllAudioLanguageReducer,
});

export default audioLanguageReducer;
